import { useParams } from 'react-router-dom'
import { AdminTitle } from '../../../../store/reducers/site';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { editeShopTimng,getShopTimeInfoByDayID } from "../../../../store/actions/shopAction";
import { errorHelper, Loader } from '../../../../utils/tools';
import { validationTimming, formTimming } from './shopValidationSchema';
import { useFormik} from 'formik';
import Divider from '@mui/material/Divider' ;
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import * as React from 'react';
//import TimePicker  from 'react-time-picker';  
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import dayjs, { Dayjs } from 'dayjs';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
//import { StaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';


import {
  
    Button,
    ButtonGroup
  

} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const EdithopTimeInfo = () => {
    let { id } = useParams();
    const [openFrom, setOpenFrom] = React.useState(dayjs('2022-04-17T15:30'));
    const [openTo, setOpenTo] = React.useState(dayjs('2022-04-17T15:30'));
  
  const [brkFrom, setBrkFrom] = React.useState(dayjs('2022-04-17T15:30'));
  const [brkTo, setBrkTo] = React.useState(dayjs('2022-04-17T15:30'));

  const [formData,setFormData] = useState(formTimming)
    const [loading,setLoading] = useState(true);




    // redux
    const shop = useSelector(state=>state.shopReducer);
 
    const dispatch = useDispatch();
    let imgUrl='/dashboard/shopsevnts';

    
    let navigate = useNavigate();
    function setStringtime (valus){
      let formattedDate = valus.format('YYYY-MM-DDTHH:mm:sss');
          return formattedDate;
    }

   

    const formik = useFormik({
        enableReinitialize:true,
       initialValues: formData,
      validationSchema:validationTimming,

        //initialValues: formAdress,
       // validationSchema:validationAdress,
        onSubmit:(values)=>{
           
            console.log("111111111111111");

            let myArray = id.split("_");
       
 
            let id1= Number(myArray[0]);
            let trns= Number(myArray[1]);
            console.log(values)
            console.log(id1)
            
              
            values.shopId=id1;
            values.dayID=trns;
            values.status='RTD'


            values.openFrom=setStringtime(openFrom);
            values.openTo=setStringtime(openTo);
            values.brkFrom=setStringtime(brkFrom);
            values.brkTo=setStringtime(brkTo);

            console.log(values.openFrom)
            console.log(values.openTo)
            console.log(values.brkFrom)
            console.log(values.brkTo)
              console.log("666666666666666666");
        
           

            dispatch(editeShopTimng(values))
            .unwrap()
            .then((response)=>{
       
                if(response!=null)
                {
                  
                    if(response.status==='ok')
                    {
                   //const id=response.id

                   console.log("55555555");
                   console.log(response)
                   //console.log(id)
                   
                   console.log("666666666666666666");
                
                  
                 navigate(`/dashboard/shop/edittimeinfo/${id1}`)
                    }
                }


                
            })
        }
    })

   



    useEffect(()=>{
        
    
        dispatch(getShopTimeInfoByDayID(id))
        .unwrap()
          .then(response => {
  
               setLoading(false);
if( response!==null){
    console.log("55555555");
    console.log(response)
    //console.log(id)
    
    console.log("666666666666666666");
 
                     
                      
         setFormData(response[0]);
        
                      }
  })
          
      },[id,dispatch])
     

    return(
        <>
        
        <AdminTitle title="Edit Shop Timming"/>
        <form className='mt-3 news_form' onSubmit={formik.handleSubmit}>
        <div className='form-group'>
        <div className='form-group'>
      

     
            <Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <FormControl fullWidth>
                <InputLabel>Select Day</InputLabel>
                <Select
                    name="dayID"
                    label="Select Day"
                    {...formik.getFieldProps('dayID')}
                    error={ formik.errors.dayID && formik.touched.dayID ? true:false}
                >

1
                    
                    <MenuItem value={1}><em>SUNDAY</em></MenuItem>
                    <MenuItem value={2}><em>MONDAY</em></MenuItem>
                    <MenuItem value={3}><em>TUESDAY</em></MenuItem>
                    <MenuItem value={4}><em>WEDNESDAY</em></MenuItem>
                    <MenuItem value={5}><em>THURSDAY</em></MenuItem>
                    <MenuItem value={6}><em>FRIDAY</em></MenuItem>
                    <MenuItem value={7}><em>SATURDAY</em></MenuItem>
                    
                </Select>
                { formik.errors.dayID && formik.touched.dayID ?
                    <FormHelperText error={true}>
                        { formik.errors.dayID}
                    </FormHelperText>
                :null
                }
            </FormControl>
</div>
<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['TimePicker','StaticTimePicker']}>
        <TimePicker
        style={{ width:'100%'}}
        name="openFrom"
          label="OPENING TIME"
          value={openFrom}
          onChange={(newValue) => setOpenFrom(newValue)}
      
        />
</DemoContainer>
</LocalizationProvider>
<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['TimePicker','StaticTimePicker']}>
<TimePicker
        style={{ width:'100%'}}
        name="openTo"
          label="CLOSING TIME"
          value={openTo}
          onChange={(newValue) => setOpenTo(newValue)}
         
        />
        </DemoContainer>

</LocalizationProvider>

            <Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <FormControl fullWidth>
                <InputLabel>Is break availble!</InputLabel>
                <Select
                    name="brkStatus"
                    label="Is break availble!"
                    {...formik.getFieldProps('brkStatus')}
                    error={ formik.errors.brkStatus && formik.touched.brkStatus ? true:false}
                >
                    
                    <MenuItem value={'Y'}><em>YES</em></MenuItem>
                    <MenuItem value={'N'}><em>NO</em></MenuItem>
                </Select>
              
                { formik.errors.brkStatus && formik.touched.brkStatus ?
                    <FormHelperText error={true}>
                        { formik.errors.brkStatus}
                    </FormHelperText>
                :null
                }
            </FormControl>
</div>
<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['TimePicker','StaticTimePicker']}>
<TimePicker
        style={{ width:'100%'}}
        name="brkFrom"
          label="BREAK STARTING TIME"
          value={brkFrom}
          onChange={(newValue) => setBrkFrom(newValue)}
         
        />
</DemoContainer>
</LocalizationProvider>
<LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['TimePicker','StaticTimePicker']}>
<TimePicker
        style={{ width:'100%'}}
        name="brkTo"
          label="BREAK ENDING  TIME"
          value={brkTo}
          onChange={(newValue) => setBrkTo(newValue)}
        
        />

</DemoContainer>
</LocalizationProvider>
          
          </div>
            <Divider className='mt-3 mb-3'/>
            <div className='form-group'>
            <FormControl fullWidth>
                <InputLabel>Is same timing for whole week?</InputLabel>
                <Select
                    name="weekStatus"
                    label="Is same timing for whole week?"
                    {...formik.getFieldProps('weekStatus')}
                    error={ formik.errors.weekStatus && formik.touched.weekStatus ? true:false}
                >
                    
                    <MenuItem value={'Y'}><em>YES</em></MenuItem>
                    <MenuItem value={'N'}><em>NO</em></MenuItem>
                </Select>
                { formik.errors.weekStatus && formik.touched.weekStatus ?
                    <FormHelperText error={true}>
                        { formik.errors.weekStatus}
                    </FormHelperText>
                :null
                }


<div className='form-group'>
                <TextField
                    style={{ width:'100%'}}
                    name="remark"
                    label="Holiday Remark "
                    variant="outlined"
                    {...formik.getFieldProps('remark')}
                    {...errorHelper(formik,'remark')}


                  
                   
                />
            </div>
            </FormControl>
</div>
       
 
        <Divider className='mt-3 mb-3'/>
          
          
            { shop.loading ?
                    <Loader/>
                :
                <Button
                    variant='contained'
                    color="primary"
                    type="submit"
                >
                    Add Timming
                </Button>
                }
</div>
        </form>
        <Divider className='mt-3 mb-3'/>
        <ButtonGroup className='me-2'>
                    <LinkContainer to={imgUrl}>
                        <Button 
                        variant='link'
                        color="orange"
                        >
                            Next
                            </Button>
                    </LinkContainer>
                </ButtonGroup>
       


        </>
    )

}

export default EdithopTimeInfo;